import * as singleSpa from 'single-spa';
import * as isActive from './activity-functions';
import { NotificationReceiverFactory } from './assets/scripts/notification-receiver';

function registerApplicationsWithAuthorization(authorizationResponse, urls, tokenResponse) {
  singleSpa.registerApplication('@venue/storage', () => System.import('@venue/storage'), isActive.storage, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    appUIUrl: window.UrlVenueAppUIStorage,
    appUrl: window.UrlVenueAppStorage,
    urls: urls
  });

  if (authorizationResponse.availablePolicies.indexOf('ProjectNotificationsRead') !== -1) {
    singleSpa.registerApplication(
      '@venue/notifications',
      () => System.import('@venue/notifications'),
      isActive.notifications,
      {
        authToken: tokenResponse.authToken,
        urls: urls,
        appUIUrl: window.UrlVenueAppUINotifications,
        authorizationData: authorizationResponse
      }
    );
  }

  singleSpa.registerApplication(
    '@venue/notifications-admin',
    () => System.import('@venue/notifications-admin'),
    isActive.notifications_admin,
    {
      authToken: tokenResponse.authToken,
      urls: urls,
      appUIUrl: window.UrlVenueAppUINotificationsAdmin,
      authorizationData: authorizationResponse
    }
  );

singleSpa.registerApplication(
    '@venue/project-header',
    () => System.import('@venue/project-header'),
    isActive.projectHeader,
    {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls
    }
);

  singleSpa.registerApplication('@venue/qna', () => System.import('@venue/qna'), isActive.qna, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUrl: window.UrlVenueAppQnA
  });

  singleSpa.registerApplication('@venue/reporting', () => System.import('@venue/reporting'), isActive.reporting, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    appUIUrl: window.UrlVenueAppUIReporting,
    urls: urls
  });

  singleSpa.registerApplication(
    '@venue/report-viewer',
    () => System.import('@venue/report-viewer'),
    isActive.reportViewer,
    {
      authToken: tokenResponse.authToken,
      authorizationData: authorizationResponse,
      appUIUrl: window.UrlVenueAppUIReportViewer,
      urls: urls
    }
  );

  singleSpa.registerApplication('@venue/teams', () => System.import('@venue/teams'), isActive.teams, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    appUIUrl: window.UrlVenueAppUITeams,
    urls: urls
  });

  window.UrlDataPrivacyUI = window.UrlVenueAppUIDataPrivacy;
  singleSpa.registerApplication(
    '@venue/data-privacy',
    () => System.import('@venue/data-privacy'),
    isActive.dataPrivacy,
    {
      authToken: tokenResponse.authToken,
      urls: urls,
      appUrl: window.UrlDataProtectApi,
      appUIUrl: window.UrlVenueAppUIDataPrivacy,
      authorizationData: authorizationResponse
    }
  );

  singleSpa.registerApplication('@venue/redaction', () => System.import('@venue/redaction'), isActive.redaction, {
    authToken: tokenResponse.authToken,
    urls: urls,
    appUrl: window.UrlDataProtectApi,
    appUIUrl: window.UrlVenueAppUIRedaction,
    authorizationData: authorizationResponse
  });

  singleSpa.registerApplication('@venue/eca', () => System.import('@venue/eca'), isActive.eca, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUIECA
  });

  singleSpa.registerApplication('@venue/projectworkflows', () => System.import('@venue/projectworkflows'), isActive.projectworkflows, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUIProjectWorkflows
  });

  singleSpa.registerApplication('@venue/archives', () => System.import('@venue/archives'), isActive.archives, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUIArchives,
    notificationReceiver: NotificationReceiverFactory.create(urls.notifications, tokenResponse.authToken) // TODO: need to stop receiver if apps is unloaded/unmounted
  });

  singleSpa.registerApplication('@venue/header', () => System.import('@venue/header'), isActive.header, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUIHeader
  });

  singleSpa.registerApplication('@venue/newhub-header', () => System.import('@venue/newhub-header'), isActive.projectList, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUINewHubHeader
  });
  
  singleSpa.registerApplication('@venue/project-list', () => System.import('@venue/project-list'), isActive.projectList, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    appUIUrl: window.UrlVenueAppUITeams,
    urls: urls
  });
 
  singleSpa.start({ urlRerouteOnly: true });
}

function registerUserAuthApplication(urls) {
  singleSpa.registerApplication(
    '@venue/auth',
    () => System.import('@venue/auth'),
    isActive.auth,
    {
      urls: urls,
      appUIUrl: window.UrlVenueAppUIAuth
    }
  );
  singleSpa.start({ urlRerouteOnly: true });
}

export { registerApplicationsWithAuthorization, registerUserAuthApplication };
